import { fetchAccountSettings } from "api/account-settings";
import { fetchCurrentUserAndAccounts } from "api/users";
import { fetchVendors } from "api/vendors";
import { fetchCategories } from "api/categories";
import { fetchCurrencies } from "api/currencies";
import { fetchEnvelopes } from "api/envelopes";
import { fetchCardNumbers } from "api/card-numbers";
import {
  fetchActiveAccount,
  fetchCustomTabs,
  fetchFavouriteAccount,
  putActiveAccount
} from "api/storage";
import {
  storage,
  DOCUMENTS_SORTING_ORDER,
  SELECTED_ACCOUNT_ID,
  VISIBLE_DOCUMENTS_COLUMNS
} from "utils/local-storage";
import { isValidValue } from "utils/validators";
import { trackIdentityAction } from "actions/shared/tracking-actions";
import { fetchPendingDocumentsAction } from "./pending-documents-actions";
import { fetchViewedBetaStatus } from "../api/storage";

export const BOOTSTRAP_CURRENT_USER_AND_ACCOUNTS = "actions/bootstrap/set-current-user-and-accounts";
export const BOOTSTRAP_VENDORS = "actions/bootstrap/bootstrap-vendors";
export const BOOTSTRAP_ENVELOPES = "actions/bootsrap/bootstrap-envelopes";
export const BOOTSTRAP_CATEGORIES = "actions/bootstrap/bootstrap-categories";
export const BOOTSTRAP_CURRENCIES = "actions/bootstrap/bootstrap-currencies";
export const LOADING_STOP = "actions/bootstrap/loading-stop";
export const BOOTSTRAP_VISIBLE_DOCUMENTS_COLUMNS = "actions/bootstrap/bootstrap-visible-documents-columns";
export const BOOTSTRAP_DOCUMENTS_ORDER = "actions/bootstrap/bootstrap-documents-order";
export const BOOTSTRAP_ACCOUNT_SETTINGS = "actions/bootstrap/bootstrap-account-settings";
export const BOOTSTRAP_CARD_NUMBERS = "actions/bootstrap/bootstrap-account-cards";
export const BOOTSTRAP_CUSTOM_TABS = "actions/bootstrap/bootstrap-custom-tabs";
export const START_FIRST_TIME_BETA_MODE = "actions/app/start-first-time-beta-mode";

export const bootstrapAction = () => (dispatch) => {
  loadSavedDocumentsColumns(dispatch);
  loadSavedDocumentsOrder(dispatch);
  return loadStoredAccountIds()
    .then(({ activeAccountId, favouriteAccountId }) => {
      fetchCurrentUserAndAccounts()
        .then(({ accounts, user }) => {
          const selectedAccount = findSelectedAccount(accounts, activeAccountId, favouriteAccountId);
          firstTimeBetaAction(dispatch);
          putActiveAccount(selectedAccount.id);
          dispatch(fetchPendingDocumentsAction(selectedAccount.id));
          dispatch({
            type: BOOTSTRAP_CURRENT_USER_AND_ACCOUNTS,
            data: { accounts: accounts.sort(accountSorter), selectedAccount, user }
          });
          dispatch(trackIdentityAction(user.id));
          // storage.remove(SELECTED_ACCOUNT_ID);
          // storage.remove(SELECTED_ACCOUNT_SLUG);
          return selectedAccount;
        })
        .then((account) => (
          Promise.all([
            dispatchCustomTabsPromise(dispatch),
            dispatchVendorsPromise(account.id, dispatch),
            dispatchCategoriesPromise(account.id, dispatch),
            dispatchCurrenciesPromise(account.id, dispatch),
            dispatchEnvelopesPromise(account.id, dispatch),
            dispatchAccountSettingsPromise(account.id, dispatch),
            dispatchCardNumbersPromise(account.id, dispatch)
          ])
        ))
        .then(() => Promise.resolve(dispatch({ type: LOADING_STOP })));
    });
};

export const loadStoredAccountIds = () => (
  Promise.all([
    fetchActiveAccount(),
    fetchFavouriteAccount()
  ])
  .then((response) => ({
    activeAccountId: response[0],
    favouriteAccountId: response[1]
  }))
);

export const findSelectedAccount = (accounts, activeAccountId, favouriteAccountId) => {
  const newSelectedAccountId = storage.get(SELECTED_ACCOUNT_ID);
  let selectedAccountId;
  if (isValidValue(newSelectedAccountId)) {
    selectedAccountId = newSelectedAccountId;
  } else if (favouriteAccountId) {
    selectedAccountId = favouriteAccountId;
  } else if (activeAccountId) { // && !favouriteid
    selectedAccountId = activeAccountId;
  } else { // && !activeAccountId)
    selectedAccountId = accounts[0].id;
  }
  const selectedAccount = accounts.find(account => account.id === selectedAccountId);
  if (selectedAccount === undefined) {
    return accounts[0];
  }
  return selectedAccount;
};

const accountSorter = (accountA, accountB) => {
  const a = accountA.label.toLowerCase();
  const b = accountB.label.toLowerCase();

  if (a > b) {
    return 1;
  }

  if (a < b) {
    return -1;
  }

  return 0;
};

const loadSavedDocumentsColumns = (dispatch) => {
  const storedValues = storage.get(VISIBLE_DOCUMENTS_COLUMNS);
  if (storedValues === null || storedValues === undefined) {
    return null;
  }

  return dispatch({
    type: BOOTSTRAP_VISIBLE_DOCUMENTS_COLUMNS,
    data: { columnKeys: JSON.parse(storedValues) }
  });
};

const loadSavedDocumentsOrder = (dispatch) => {
  const storedValue = storage.get(DOCUMENTS_SORTING_ORDER);
  if (storedValue === null || storedValue === undefined) {
    return null;
  }
  const data = JSON.parse(storedValue);
  return dispatch({
    type: BOOTSTRAP_DOCUMENTS_ORDER,
    data
  });
};

const dispatchAccountSettingsPromise = (accountId, dispatch) => fetchAccountSettings(accountId)
  .then(({ accountSettings }) => {
    dispatch({
      type: BOOTSTRAP_ACCOUNT_SETTINGS,
      data: { accountSettings }
    });
  });

const dispatchVendorsPromise = (accountId, dispatch) => fetchVendors(accountId)
  .then(({ vendors }) => {
    dispatch({
      type: BOOTSTRAP_VENDORS,
      data: { vendors }
    });
  });

const dispatchCategoriesPromise = (accountId, dispatch) => fetchCategories(accountId)
  .then(({ categories }) => {
    dispatch({
      type: BOOTSTRAP_CATEGORIES,
      data: { categories }
    });
  });

const dispatchCurrenciesPromise = (accountId, dispatch) => fetchCurrencies(accountId)
  .then(({ currencies }) => {
    dispatch({
      type: BOOTSTRAP_CURRENCIES,
      data: { currencies }
    });
  });

const dispatchEnvelopesPromise = (accountId, dispatch) => fetchEnvelopes(accountId)
  .then(({ envelopes }) => {
    dispatch({
      type: BOOTSTRAP_ENVELOPES,
      data: { envelopes }
    });
  });

const dispatchCardNumbersPromise = (accountId, dispatch) => fetchCardNumbers(accountId)
  .then(({ cardNumbers }) => {
    dispatch({
      type: BOOTSTRAP_CARD_NUMBERS,
      data: { cardNumbers }
    });
  });

const dispatchCustomTabsPromise = (dispatch) => fetchCustomTabs()
  .then((response) => {
    if (response) {
      dispatch({
        type: BOOTSTRAP_CUSTOM_TABS,
        data: { customTabs: response }
      });
    }
  });

export const firstTimeBetaAction = (dispatch) => (
  fetchViewedBetaStatus()
    .then((response) => {
      if (response) {
        return null;
      }
      return dispatch({ type: START_FIRST_TIME_BETA_MODE });
    })
);



// WEBPACK FOOTER //
// ./src/js/actions/bootstrap-actions.js